/**
 * @author    Alex Mischarin <Alex.Mischarin@brewes.de>
 * @copyright 2023-2025 Brewes GmbH
 * @link      https://www.brewes.de/
 */

define([
    'jquery',
    'Brewes_Matomo/js/matomo-storage',
    'mage/cookies',
    'domReady!'
], function ($, matomoStorage) {
    'use strict';

    return function (config) {
        const storage = matomoStorage();
        const MATOMO_USER_ID = 'matomo-user-id';
        const data = config;
        const matomoUserId = $.mage.cookies.get(MATOMO_USER_ID);
        const currentUrl = encodeURIComponent(window.location.href.split('?')[0]);
        const openChat = document.querySelector('li.open-chat > a');
        const feedbackForm = document.querySelector('#modal-feedback .pccform');
        const newsletterForm = document.querySelector('#newsletter-validate-detail');
        const accountForm = document.querySelector('#create .account-form__form');
        const filterCollection = document.querySelectorAll('.filter');
        const activeFilterCollection = document.querySelectorAll('.active-filters .active-filters__remove');
        const searchInput = document.getElementById('search');
        const pageId = storage.getValue('p');
        const matomoRequestBaseUrl = `${data['apiUrl']}?idsite=${data['siteId']}&rec=1&pv_id=${pageId}` +
            `${matomoUserId ? '&uid=' + matomoUserId : ''}&url=${encodeURIComponent(window.location.href)}`;

        // tracking filter select event
        if (activeFilterCollection.length) {
            for (const activeFilter of activeFilterCollection) {
                const activeFilterLabel = activeFilter.querySelector('.active-filters__label');

                if (activeFilterLabel) {
                    activeFilter.addEventListener('click', () => {
                        const activeFilterLabelText = activeFilterLabel.textContent
                            .trim()
                            .replace(':', '');

                        sendXmlHttp(
                            'GET',
                            encodeURI(matomoRequestBaseUrl
                                + `&e_c=${data['filterOff']}&e_a=${currentUrl}&e_n=${activeFilterLabelText}`));
                    });
                }
            }
        }

        // setup source and url for newsletter subscription event with registration form
        if (filterCollection.length) {
            const filterButtonSelector = '.filter__content .button:not(.more-info__trigger, .more-info__close)';

            for (const filter of filterCollection) {
                let filterButton = filter.querySelector(filterButtonSelector);

                if (!filterButton) {
                    let existCondition = setInterval(function () {
                        filterButton = filter.querySelector(filterButtonSelector);

                        if (filterButton) {
                            clearInterval(existCondition);
                            setFilterOnEvent(filterButton, filter);
                        }
                    }, 500);
                }
                else {
                    setFilterOnEvent(filterButton, filter);
                }
            }
        }

        // setup source and url for newsletter subscription event with form
        if (accountForm) {
            setHiddenValue(accountForm, 'source', $.mage.__('Account source'));
            setHiddenValue(accountForm, 'locator', window.location);
        }

        // setup page url for feedback event
        if (newsletterForm) {
            setHiddenValue(newsletterForm, 'source', $.mage.__('Form source'));
            setHiddenValue(newsletterForm, 'locator', window.location);
        }

        // tracking opening chat
        if (feedbackForm) {
            setHiddenValue(feedbackForm, 'locator', window.location);
        }

        // tracking search input
        if (searchInput) {
            const keyword = sessionStorage.getItem('matomoSearch');

            if (keyword) {
                sendXmlHttp(
                    'GET',
                    encodeURI(matomoRequestBaseUrl
                        + `&e_c=${data['userActivity']}&e_a=${data['search']}`
                        + `&e_n=${escapeHtmlEntities(keyword.toLowerCase())}`));

                sessionStorage.removeItem('matomoSearch');
            }

            $(searchInput).on('keyup', function () {
                sessionStorage.setItem('matomoSearch', $(searchInput).val());
            });
        }

        // tracking opening chat
        if (openChat) {
            openChat.addEventListener('click', () => {
                sendXmlHttp(
                    'GET',
                    encodeURI(matomoRequestBaseUrl
                        + `&e_c=${data['contact']}&e_a=${data['chat']}`
                        + `&e_n=${encodeURIComponent(window.location.href)}`));
            });
        }

        /**
         * Add hidden input to form
         *
         * @param form
         * @param name
         * @param value
         */
        function setHiddenValue(form, name, value) {
            const hiddenInput = document.createElement('input');

            hiddenInput.setAttribute('type', 'hidden');
            hiddenInput.setAttribute('name', name);
            hiddenInput.setAttribute('value', value);
            form.appendChild(hiddenInput);
        }

        /**
         * Create Matomo tracking event for filter select
         *
         * @param element
         * @param filter
         */
        function setFilterOnEvent(element, filter) {
            if (element) {
                element.addEventListener('click', () => {
                    const filterLabelSelector = 'button.dropdown-list__label .filter__heading';
                    const filterLabel = filter.querySelector(filterLabelSelector).textContent.trim();

                    sendXmlHttp('GET', encodeURI(matomoRequestBaseUrl
                        + `&e_c=${data['filterOn']}&e_a=${currentUrl}&e_n=${escapeHtmlEntities(filterLabel)}`));
                });
            }
        }

        /**
         * Send HTTP request
         *
         * @param {string} method
         * @param {string} url
         * @param {string|null} payload
         */
        function sendXmlHttp(method, url, payload = null) {
            const xmlHttp = new XMLHttpRequest();

            xmlHttp.open(method, url);
            xmlHttp.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xmlHttp.setRequestHeader('Access-Control-Allow-Origin', '*');
            xmlHttp.send(payload);
        }

        /**
         * Escape special characters from input
         *
         * @param {string} unsafe
         * @return {string}
         */
        function escapeHtmlEntities(unsafe) {
            return unsafe
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
        }
    };
});
//# sourceMappingURL=brewes-matomo-events.babel.js.map
